import $ from 'jquery'
import {Errors} from './constants'
import ChartDateRangeSectionStrategy from './ChartDateRangeSectionStrategy'

function DateRangeChartDateRangeSectionStrategy() {}

DateRangeChartDateRangeSectionStrategy.prototype = new ChartDateRangeSectionStrategy();

DateRangeChartDateRangeSectionStrategy.prototype.updateSectionUI = function()
{
    ChartDateRangeSectionStrategy.prototype.updateSectionUI.call( this );
    $( this.container ).addClass( "withDateRangeSelector" );
};

DateRangeChartDateRangeSectionStrategy.prototype.getSelectedParamsJSON = function()
{
    return { dateRangeSelection: this.dateRangeSelector.getSelectedRangeJSON() };
};

DateRangeChartDateRangeSectionStrategy.prototype.getSelectedParams = function()
{
    return { dateRangeSelection: this.dateRangeSelector.getSelectedRange() };
};

DateRangeChartDateRangeSectionStrategy.prototype.validate = function()
{
    if ( this.dateRangeSelector.hasErrors() )
        return [ Errors.ERROR_INCORRECT_DATE_RANGE ];
    return [];
};

export default DateRangeChartDateRangeSectionStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/DateRangeChartDateRangeSectionStrategy.js